import { AfterViewInit, Component, input, OnDestroy, output, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, filter, tap } from 'rxjs/operators';

@Component({
  selector: 'dbx-entity-select',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslatePipe,
  ],
  templateUrl: './entity-select.component.html',
  styleUrl: './entity-select.component.scss',
})
export class EntitySelectComponent implements AfterViewInit, OnDestroy {
  items = input<any[]>([]);
  loading = input<boolean>(false);
  completed = input<boolean>(false);
  selectedItem = input<any>(null);
  displayFn = input<(item: any) => string>((item: any) => item?.name ?? '');
  compareFn = input<(a: any, b: any) => boolean>((a: any, b: any) => (a && b ? a.id === b.id : a === b));
  placeholder = input<string>('');

  selected = output<any>();
  search = output<string>();
  loadMore = output<void>();

  @ViewChild(MatSelect) matSelect!: MatSelect;

  searchControl = new FormControl('');

  private subscriptions: Subscription[] = [];

  ngAfterViewInit(): void {
    this.matSelect.openedChange.subscribe((opened) => {
      if (opened) {
        setTimeout(() => {
          const panel = document.querySelector('.mat-mdc-select-panel') as HTMLElement;
          if (panel) {
            this.attachScrollListener(panel);
          }
        });
        this.subscriptions.push(
          this.searchControl.valueChanges
            .pipe(
              debounceTime(300),
              tap((searchText) => this.search.emit(searchText ?? '')),
            )
            .subscribe(),
        );
      } else {
        if (this.searchControl.value) {
          this.clearSearch();
          this.search.emit('');
        }
        this.subscriptions.forEach((s) => s?.unsubscribe());
        this.subscriptions = [];
      }
    });
  }

  clearSearch(): void {
    this.searchControl.patchValue('');
  }

  attachScrollListener(panel: HTMLElement): void {
    this.subscriptions.push(
      fromEvent(panel, 'scroll')
        .pipe(
          debounceTime(300),
          filter(() => !this.loading() && !this.completed()),
          filter(() => panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 10),
          tap(() => this.loadMore.emit()),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s?.unsubscribe());
  }
}
